"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleCollectionToDataTransformer = void 0;
const Collection_1 = require("../Model/Collection");
/**
 * Transforms the inputs of the form into a customer object.
 */
class VehicleCollectionToDataTransformer {
    constructor(vehicleTransformer) {
        this.vehicleTransformer = vehicleTransformer;
    }
    /**
     * @inheritDoc
     * @param {CollectionInterface<Vehicle>} vehicleCollection
     * @returns {*[]}
     */
    to(vehicleCollection) {
        return vehicleCollection.reduce([], (value, item) => {
            value.push(this.vehicleTransformer.to(item));
            return value;
        });
    }
    /**
     * @inheritDoc
     * @param {*[]} data
     * @returns {CollectionInterface<Vehicle>}
     */
    from(data) {
        return new Collection_1.default(data.map(this.vehicleTransformer.from.bind(this.vehicleTransformer)));
    }
}
exports.VehicleCollectionToDataTransformer = VehicleCollectionToDataTransformer;
